module.exports = __webpack_public_path__ + "media/images/thorrel-logo-120-3e3a3cb8fc2d13fa61d20db846179449.png";